import styled from 'styled-components';
import { Switch } from 'antd';

import FlexBox from '../../FlexBox';
import Button from './Button';
import SubmitButton from './SubmitButton';
import Modal from './Modal';
import Input from './Input';
import Select from './Select';
import FormItem from './FormItem';
import Checkbox from './Checkbox';
import Payment from './Payment';

const Card = styled.div`
  width: 100%;
  margin-top: 30px;
  position: relative;
`;

const CardTitle = styled.h3`
  display: flex;
  color: #333 !important;
  font-size: 16px;
  line-height: 1;
  margin-bottom: 10px;

  i {
    margin-top: -1px;
    margin-right: 8px;
    color: #666;
    font-weight: normal;
  }
`;

const CardBody = styled(FlexBox)`
  border: 1px solid #e6e6e6;

  .m-body-row:last-child {
    border-bottom: 0;
  }
`;

Card.Title = CardTitle;
Card.Body = CardBody;

const Row = styled(FlexBox).attrs(props => ({
  'className': props['m-body-row'],
}))`
  align-items: ${({ align }) => align || 'center'};
  width: 100%;
  padding: 0px 16px;
  height: 50px;
  line-height: 1;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom: ${({ noborder }) => (noborder ? 'none' : '1px solid #e6e6e6')};
`;

const Col = styled(FlexBox)`
  color: #333;
  font-size: 14px;
  padding: 5px 0;

  &.one {
    flex: 0 0 200px;
  }
  &.two {
    flex: 0 0 220px;
    padding-right: 10px;
  }
  &.three {
    flex: 1;
    font-size: 12px;
  }
  &.four {
    flex: 0 0 100px;
  }

  .gap {
    margin-right: 5px;
  }

  &.ellipsis {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

const SwitchStyle = styled(Switch)`
  width: 54px;
  height: 24px;
  line-height: 22px;
  &.ant-switch-checked {
    background-color: #70a800;
  }
  &.ant-switch::after {
    top: 2px;
  }
`;

export {
  Button,
  Card,
  Row,
  Col,
  SwitchStyle as Switch,
  Modal,
  Input,
  FormItem,
  SubmitButton,
  Select,
  Checkbox,
  Payment,
};
